import { convertFullMonthNamesToShort, customCategories } from '.';
import { colors, primaryColors } from '../constants';
import cities from '../components/shared/usaCountryCityChart/city.json';

export const getLabels = (array = [], key) => {
    if (!key) return [];

    const data = [];
    array.forEach((item) => {
        data.push(item[key]);
    });

    return data;
};

export const createChartData = (data = [], key, isPrimaryColor = false,shortMonth = false,customMonth = false,isSessionDuration=false,isRepeatEngagement=false) => {
    let labels = getLabels(data, 'month');
    if(shortMonth){
        if(customMonth){
            labels = customCategories(labels);
        } else{
            labels = convertFullMonthNamesToShort(labels);
        }
    }
    const keys = ['sessions_value', 'quality_visits_value', 'count'];
    const bool = keys.includes(key);
    let dataSets = [], allValuesZero;
    if (bool) {
        dataSets = data.map((item, index) => ({
            name: item['month'],
            y: item[key],
            color: isPrimaryColor ? '#AD509E' : colors[index]
        }));
        allValuesZero = dataSets.every(item => item.y === 0);
        dataSets = allValuesZero ? [] : dataSets;
    } else {
        let tempArray = {}, COLOR_COUNT = 0;
    
        data.forEach((item) => {
            const nestedObj = item?.[key];
            const newItemArray = nestedObj && typeof nestedObj === 'object' ? Object.keys(nestedObj) : [];
    
            if (COLOR_COUNT < newItemArray.length) {
                COLOR_COUNT = newItemArray.length;
            }
    
            newItemArray.sort((a, b) => (a > b ? 1 : -1));
    
            newItemArray.forEach((name) => {
                if (!tempArray[name]) tempArray[name] = [];
                tempArray[name].push(nestedObj[name]);
            });
        });
    
        const tempItemArray = Object.keys(tempArray);
        tempItemArray.forEach((key, index) => {
            dataSets.push({
                name: key,
                data: tempArray[key],
                fillColor: colors[index]
            });
        });
    
        allValuesZero = dataSets.every(item => item.data.every(value => value === 0));
        dataSets = allValuesZero ? [] : dataSets;
    }
    
    if(isSessionDuration){
        const order = ['90+ Seconds', '60-90 Seconds', '30-60 Seconds', '<30 seconds'];
        dataSets= dataSets.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
    }
    if(isRepeatEngagement){
        dataSets = dataSets.sort((a,b)=>parseInt(b.name[0]) - parseInt(a.name[0]));
    }
    return {
        xAxisCategories: labels, dataSets, colors 
    };
};

export const makeQualityVisitBarData = (data) => {
    const barData = [{
        name: '',
        data: []
    }];
    const categories = [];
    if(data?.length){
        const hasData = data.some(obj => obj.quality_visits_value > 0);
        if(hasData){
            data.forEach(item => {
                categories.push(item?.month);
                barData[0].data.push(parseInt(item.quality_visits_value));
            });
        }
    }
    return { barData, categories };
};
export const DonutChartData = (data = [], type) => 
    data.filter((value) => parseFloat(value.percentage) > 0)
        .map((value) => ({
            name: type === 'age' ? value.age_group : type === 'gender' ? value.gender_group : value.device_type,
            y: parseFloat(value.percentage)
        }));
  

export const generateCityCode = (city) => {
    const cityData = cities.objects.default.geometries.filter(item => item.properties.name === city);
    if (cityData.length > 0) {
        return cityData[0].properties['hc-key'];
    } else {
        return null;
    }
};

export const createCityData = (cityEngagement) => {
    const result = [];
    if (cityEngagement.length) {
        cityEngagement.forEach(item => {
            const code = generateCityCode(item.city);
            if (code && item.count > 0) {
                result.push({
                    code: code,
                    name: `${item.city}, ${item.state}`,
                    value: item.count
                });
            }
        });
    }
    return result;
};

export const makepaidMediaSummaryBarData = (data) => {
    const barData = [{
        name: '',
        data: []
    }];
    const categories = [];
    if(data?.length){
        const hasData = data.some(obj => obj.total_engagements > 0);
        if(hasData){
            data.forEach(item => {
                categories.push(item?.month);
                barData[0].data.push(parseInt(item.total_engagements));
            });
        }
    }
    return { barData, categories };
};

export const dtcProcessDataForClickEngagement = (selectedChannel, channelData) => {
    let data = [];

    if (selectedChannel?.toLowerCase() === 'all') {
        let channelValues = Object?.entries(channelData)?.map(([channel, value]) => ({
            name: channel,
            value: Object?.values(value)?.reduce((acc, val) => acc + val, 0)
        }));
        channelValues = channelValues?.filter(channel => channel.value !== 0);

        channelValues?.sort((a, b) => b.value - a.value);

        data = channelValues?.map(channel => ({
            name: channel.name,
            data: Object?.values(channelData[channel.name])
        }));

        return data;
    } else {
        data = Object?.entries(channelData)?.map((item, index ) => {
            const [channel, value] = item;
            return {
                x: channel,
                y: value[selectedChannel] || 0,
                fillColor: primaryColors[index] 
            };
        });
        return [
            {
                name: selectedChannel,
                data: data
            }
        ];
    }
};

export const capitalizeKeys = (obj={}) => {
    const capitalizeWords = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());
    
    const newObj = {};
    for (const key in obj) {
        const value = obj[key];
        const newKey = capitalizeWords(key);
  
        if (typeof value === 'object' && value !== null) {
            newObj[newKey] = capitalizeKeys(value);
        } else {
            newObj[newKey] = value;
        }
    }
    return newObj;
};

export const convertPaidSummaryData = (data = []) => {
    // Check if the input data is empty
    if (!data?.length) {
        return [];
    }

    // Use reduce to group and calculate total engagements by year-month
    const aggregatedData = data.reduce((acc, item) => {
        const [year, month] = item.datestamp.split('-').slice(0, 2);
        const key = `${year}-${month}`;

        if (!acc[key]) {
            acc[key] = { month: key, total_engagements: 0 };
        }

        acc[key].total_engagements += item.total_engagements;
        return acc;
    }, {});

    // Convert the aggregated object back to an array
    return Object.values(aggregatedData);
};
export function transformIntoCostData(inputData) {
    const resultMap = new Map();
    const allChannels = new Set();
    inputData.forEach(({
        month, channel, cost 
    }) => {
        allChannels.add(channel);
        if (!resultMap.has(month)) {
            resultMap.set(month, { month, source_medium_group_data: {} });
        }
        resultMap.get(month).source_medium_group_data[channel] = Number(parseFloat(cost).toFixed(2));
    });
    resultMap.forEach((entry) => {
        [...allChannels].forEach(channel => {
            if (!(channel in entry.source_medium_group_data)) {
                entry.source_medium_group_data[channel] = 0;
            }
        });
    });

    return Array.from(resultMap.values());
}

export const createUsersAreaChartSeries = (newusers = [], returningUsers = []) => {
    const newUserSeries = newusers?.map((user) => ({
        x: convertFullMonthNamesToShort([],user.month),
        y: Math.round(user.count ?? 0)
    }));

    const returningUsersSeries = returningUsers?.map((item) => ({
        x: convertFullMonthNamesToShort([],item.month),
        y: Math.round(item?.rest_count ?? item?.count ?? 0)
    }));

    return [
        {
            name: 'New Users',
            data: newUserSeries
        },
        {
            name: 'Returning Users',
            data: returningUsersSeries
        }
    ];
};
export function transformDataForStackedBar(data) {
    data.sort((a, b) => a.month.localeCompare(b.month));
    const months = [...new Set(data.map(item => item.month))];
    const channelMap = {};

    data.forEach(({
        month, channel, cost 
    }) => {
        if (!channelMap[channel]) {
            channelMap[channel] = [];
        }
        
        const monthIndex = months.indexOf(month);
        channelMap[channel][monthIndex] = cost;
    });
    const transformedData = Object.entries(channelMap).map(([name, costs]) => ({
        name,
        data: costs
    }));

    return { categories: months, series: transformedData };
}

export function transformSessionDurationData(data=[]) {
    const order = ['90+ Seconds', '60-90 Seconds', '30-60 Seconds', '<30 seconds'];
    if(data && data.length){
        const grouped = data?.reduce((acc, {
            month, breakdown, avg_value 
        }) => {
            if (!acc[month]) acc[month] = {};
            acc[month][breakdown] = parseFloat(avg_value?.toFixed(2));
            return acc;
        }, {});
    
        return Object.entries(grouped)?.map(([month, breakdowns]) => ({
            month,
            source_medium_group_data: order?.reduce((sortedObj, key) => {
                if (key in breakdowns) {
                    sortedObj[key] = breakdowns[key];
                }
                return sortedObj;
            }, {})
        }));
    }
    return data;
}

export function transformRepeatEngagement(data=[]) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
    if(data && data.length){
        return data.map(({ month, ...rest }) => ({
            month: `${monthNames[+month.split('-')[1] - 1]} ${month.split('-')[0]}`,
            source_medium_group_data: rest
        }));
    }
    return data;
}

export const createChartDataForRepeatEngagement = (data = [], key, isPrimaryColor = false, shortMonth = false, customMonth = false, isSessionDuration = false, isRepeatEngagement = false) => {
    let labels = getLabels(data, 'month');
    if (shortMonth) {
        if (customMonth) {
            labels = customCategories(labels);
        } else {
            labels = convertFullMonthNamesToShort(labels);
        }
    }

    const keys = ['sessions_value', 'quality_visits_value', 'count'];
    const bool = keys.includes(key);
    let dataSets = [], allValuesZero;

    if (bool) {
        dataSets = data.map((item, index) => ({
            name: item['month'],
            y: item[key],
            color: isPrimaryColor ? '#AD509E' : colors[index]
        }));
        allValuesZero = dataSets.every(item => item.y === 0);
        dataSets = allValuesZero ? [] : dataSets;
    } else {
        let tempArray = {}, COLOR_COUNT = 0;
        const allKeys = new Set();
        data.forEach(item => {
            Object.keys(item[key]).forEach(name => allKeys.add(name));
        });
        const allKeysArray = Array.from(allKeys).sort();

        allKeysArray.forEach((name) => {
            tempArray[name] = [];
            data.forEach((item) => {
                tempArray[name].push(item[key][name] || 0);
            });
        });

        COLOR_COUNT = allKeysArray.length;
        allKeysArray.forEach((keyName, index) => {
            dataSets.push({
                name: keyName,
                data: tempArray[keyName],
                fillColor: colors[index]
            });
        });

        allValuesZero = dataSets.every(item => item.data.every(value => value === 0));
        dataSets = allValuesZero ? [] : dataSets;
    }

    if (isSessionDuration) {
        const order = ['90+ Seconds', '60-90 Seconds', '30-60 Seconds', '<30 seconds'];
        dataSets = dataSets.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
    }

    if (isRepeatEngagement) {
        dataSets = dataSets.sort((a, b) => {
            const extractNumber = str => {
                const match = str.match(/\d+/);
                return match ? parseInt(match[0]) : 0;
            };
            return extractNumber(b.name) - extractNumber(a.name);
        });
    }
    return {
        xAxisCategories: labels,
        dataSets,
        colors
    };
};

export const createAreaChartSeries = (sessions = [], qvr = [], engagedSession = []) => {
    const sessionsSeries = sessions?.map((session) => ({
        x: convertFullMonthNamesToShort([],session.month),
        y: Math.round(session.sessions_value ?? 0)
    }));

    const qvrSeries = qvr?.map((item) => ({
        x: convertFullMonthNamesToShort([],item.month),
        y: Math.round(item.quality_visits_value ?? 0)
    }));

    return [
        {
            name: 'Sessions',
            data: sessionsSeries
        },
        {
            name: 'Quality Visits',
            data: qvrSeries
        }
    ];
};

export const createSameKeyData = (data=[]) =>{
    const allKeys = new Set();
    data.forEach(entry => {
        Object.keys(entry.source_medium_group_data).forEach(key => {
            allKeys.add(key);
        });
    });
    data.forEach(entry => {
        const group = entry.source_medium_group_data;
        [...allKeys].forEach(key => {
            if (!(key in group)) {
                group[key] = 0;
            }
        });
    });
    return data;
};